import * as tslib_1 from "tslib";
var FindResult = /** @class */ (function () {
    function FindResult(tree, indexInParentsChildrenArray) {
        this.tree = tree;
        this.indexInParentsChildrenArray = indexInParentsChildrenArray;
    }
    return FindResult;
}());
export { FindResult };
var Tree = /** @class */ (function () {
    function Tree(data, parent, childrenData) {
        var e_1, _a;
        if (parent === void 0) { parent = null; }
        if (childrenData === void 0) { childrenData = []; }
        this.name = data.name;
        this.description = data.description;
        this.data = data;
        this.parent = parent;
        this.children = [];
        try {
            for (var childrenData_1 = tslib_1.__values(childrenData), childrenData_1_1 = childrenData_1.next(); !childrenData_1_1.done; childrenData_1_1 = childrenData_1.next()) {
                var d = childrenData_1_1.value;
                this.children.push(new Tree(d, this));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (childrenData_1_1 && !childrenData_1_1.done && (_a = childrenData_1.return)) _a.call(childrenData_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    Tree.prototype.findByName = function (name) {
        var e_2, _a;
        //determine if this tree is the match
        if (this.name === name) {
            if (this.parent === null) {
                //when parent is null, there is no index of this node in parent's children array, return null there
                return new FindResult(this, null);
            }
            else {
                //when a parent to this node exists, get the index of this node in the parent's children array to pass back
                //to the caller
                return new FindResult(this, this.parent.getIndexOfChildByName(name));
            }
        }
        try {
            for (var _b = tslib_1.__values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                //recurse through the children until one is found
                var findRes = child.findByName(name);
                if (findRes) {
                    return findRes;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        //if not this node and any children node, not present in this tree
        return null;
    };
    Tree.prototype.getIndexOfChildByName = function (name) {
        var e_3, _a;
        try {
            for (var _b = tslib_1.__values(this.children.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), i = _d[0], child = _d[1];
                if (child.name === name) {
                    return i;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return null;
    };
    Tree.prototype.addChild = function (data) {
        this.children.push(new Tree(data, this));
    };
    Tree.prototype.addChildTo = function (parentName, data) {
        //find a tree in this tree matching the specified name
        var searchRes = this.findByName(parentName);
        if (searchRes) {
            searchRes.tree.addChild(data);
            return true;
        }
        else {
            return false;
        }
    };
    Tree.prototype.remove = function (name) {
        //find a tree in this tree matching the specified name
        var searchRes = this.findByName(name);
        if (searchRes && searchRes.indexInParentsChildrenArray !== null) {
            //remove this node from it's parent's children array at the index specified
            //in the return results
            searchRes.tree.parent.children.splice(searchRes.indexInParentsChildrenArray, 1);
            return true;
        }
        else {
            return false;
        }
    };
    Tree.prototype.getPathTo = function () {
        //if this node has no parent, no path to it exists
        if (!this.parent) {
            return [];
        }
        //go over all the parents of the parents to this node, push them to the array
        var returnArr = [];
        var parentCheck = this.parent;
        while (parentCheck) {
            returnArr.push(parentCheck);
            parentCheck = parentCheck.parent;
        }
        //reverse so the array goes Top Level - This Node
        returnArr.reverse();
        return returnArr;
    };
    return Tree;
}());
export { Tree };
